var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-button',{attrs:{"color":"success","type":"filled"},on:{"click":_vm.geoFindMe}},[_vm._v("Success")]),_c('p',{attrs:{"id":"status"}}),_c('p',{attrs:{"id":"map-link"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }